import React, {useEffect} from 'react';
import FlexBox from "../../components/FlexBox/FlexBox";
import Tile from "../../components/Icons/components/Tile";
import mObywatelIcon from "../../components/Icons/mObywatel_icon_orange.svg";
import StandardFormIcon from "../../components/Icons/standardForm_icon.png";
import styled from "styled-components";
import Tooltip from "../../components/Tooltip/Tooltip";
import RentSubtitle from "../RentSteps/components/RentSubtitle";
import useAuthologicContext from "./useAuthologic";


const SelectPersonalDataProviderMobile = ({disabled}) => {
    const {changeStatus, status, isError} = useAuthologicContext()

    const handleClick = (e) => {
        changeStatus(e.target.value);
    }

    useEffect(() => {
        if (isError && status === 'active') {
            changeStatus('STANDARD_FORM')
        }
    }, [isError, status, changeStatus])

    return (
        <Container>
            <RentSubtitle>Wybór formularza</RentSubtitle>
            <RadioContainer disabled={disabled}>
                <FlexBox justifyContent='center' flex="1" gap={'0rem'} flexDirection={'column'}>
                    <InputGroup>
                        <IconLabel htmlFor="mObywatel">
                            <MobileTile
                                icon={
                                    <img src={mObywatelIcon} alt="mObywatel" style={{width: 45, height: 45}}/>
                                }
                                active={status === 'active'}
                                disabled={isError || disabled}
                            />
                            <input
                                type='radio'
                                id='mObywatel'
                                value='mObywatel'
                                onClick={handleClick}
                                disabled={isError}
                            />
                        </IconLabel>
                        <TileDescriptionMobile>
                            Formularz <StickedTootlip>mObywatel
                            <TooltipContainer>
                                <Tooltip className='tooltip' description="Ta opcja pozwala na weryfikację tożsamości z wykorzystaniejm aplikacji mObywatel. Twoje dane są bezpieczne i chronione zgodnie z najwyższymi standardami bezpieczeństwa." />
                            </TooltipContainer>
                        </StickedTootlip>
                            <br/>
                            <span className={''}>(weryfikacja danych za pomocą<br/>aplikacji mObywatel)</span>
                        </TileDescriptionMobile>
                    </InputGroup>
                    <InputGroup>
                        <IconLabel htmlFor="STANDARD_FORM">
                            <MobileTile
                                icon={
                                    <img src={StandardFormIcon} alt="mObywatel" style={{width: 45, height: 45}}/>
                                }
                                active={status !== 'active'}
                                isMobile={true}
                            />
                            <input
                                type='radio'
                                id='STANDARD_FORM'
                                value='STANDARD_FORM'
                                onClick={handleClick}
                                disabled={disabled}
                            />
                        </IconLabel>
                        <TileDescriptionMobile>
                            Formularz <StickedTootlip>
                                standardowy
                            <TooltipContainer>
                                <Tooltip className='tooltip' description="Twoje dane są bezpieczne i chronione zgodnie z najwyższymi standardami bezpieczeństwa." />
                            </TooltipContainer>
                            </StickedTootlip>
                            <br/>
                            <span>(samodzielne wypełnienie danych)</span>
                        </TileDescriptionMobile>
                    </InputGroup>
                </FlexBox>
            </RadioContainer>
        </Container>
    );
}

export default SelectPersonalDataProviderMobile;

const RadioContainer = styled.div`
  border: 1px solid ${({theme, isError}) => (isError ? theme.danger : "transparent")};
  padding: 10px;
  margin: 10px;
  display: flex;
  opacity: ${props => props.disabled ? .5 : 1};


  label > span {
    font-weight: bold;
  }
`;

const InputGroup = styled.div`
  font-size: 1.125rem;
  font-weight: bold;
  display: flex;
  margin-top: 20px;
`;

const IconLabel = styled.label`
  display: inline-block;
  cursor: pointer;

  & > input {
    position: absolute;
    display: block;
    width: 0px;
    height: 0px;
    opacity: 0;
    top: -1000px;
    left: -1000px;
  }
`;

const TileDescription = styled.p`
  line-height: 24px;
`;

const Container = styled.div`
  margin-top: 30px;
`;

const TooltipContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-left: 5px;
  margin-top: -3px;
`;

const MobileTile = styled(Tile)`
  max-width: 100px;
  max-height: 100px;
  border-radius: 10px;
  img {
    max-width: 50px;
  }
`;
const TileDescriptionMobile = styled(TileDescription)`
    text-align: left;
    margin-left: 20px;
  font-size: 17px;
  span {
    font-size: 14px;
    line-height: 20px;
    display: block;
    margin-top: 2px;
    color: gray;
    font-weight: 500;
  }
`;

const StickedTootlip = styled.div`
    display: inline;
    white-space: pre;
`
